import React from 'react'
import { AddButton } from '@e3dc-react/shell/Elements/Buttons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface AssignNewTariffButtonProps {
  onAddTariff: () => void
}

/**
 * button for add new select field in tariffs field array
 * @param onAddTariff - function for adding new tariff in tariff form field array
 */
export const AssignNewTariffButton: React.FC<AssignNewTariffButtonProps> = ({ onAddTariff }) => {
  const { t } = useCustomTranslation()

  return <AddButton buttonProps={{ color: 'success' }} onClick={onAddTariff} label={t('emobility.wallbox.editTariffs.addTariff')} />
}
